import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CommunicationService } from '../services/communication.service';
import { take } from 'rxjs/operators';

/**
 * We specifically use this resolver to deal with the situation that a user has landed on the home page from a URL that sets a location for the map.
 *
 * In this situation we want to overwrite retrieving the user location and setting that with the location from the url.
 *
 * Example: /on/ or /on/cornwall-real-estate
 */
@Injectable()
export class CommunicationSearchingResolver implements Resolve<boolean> {

  constructor(private _router: Router, private _communicationService: CommunicationService) { }

  resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot): Observable<boolean> {
    return this._communicationService.searching.shouldCenterAtUserLocation.pipe(take(1));
  }
}
